var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4998L7.49917 19.4992V14.9997H20.9977V12H7.49917V7.50049L0 13.4998Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.1536e-05C14.7265 -0.00486597 12.9696 0.34218 11.3312 1.02108C9.69278 1.69999 8.20535 2.69726 6.95508 3.95511L9.07584 6.07588C11.0586 4.0931 13.6953 2.99972 16.5 2.99972C19.3047 2.99972 21.9414 4.0931 23.9242 6.07588C25.907 8.05866 27.0004 10.6954 27.0004 13.5001C27.0004 16.3048 25.907 18.9415 23.9242 20.9242C21.9414 22.907 19.3047 24.0004 16.5 24.0004C13.6953 24.0004 11.0586 22.907 9.07584 20.9242L6.95508 23.045C9.5033 25.5947 12.8929 27.0001 16.5 27.0001C20.1071 27.0001 23.4968 25.5947 26.045 23.045C28.5947 20.4968 30 17.1072 30 13.5001C30 9.89296 28.5947 6.50333 26.045 3.95511C24.7947 2.69726 23.3073 1.69999 21.6688 1.02108C20.0304 0.34218 18.2735 -0.00486597 16.5 5.1536e-05V5.1536e-05Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9d66859cdef3e2b2cea25ddc14c5ad5f.svg";
export { ForwardRef as ReactComponent };